// `_noop` : an utility's function
// --------------------------------

// `noop` function
export default function () {}